//Core
import React from "react"

//Styles
import style from "./style.module.scss"

//Components
import PromoItem from "./PromoItem"

//Images
import cashnow from "../../images/dashboard/cashnow.jpg"

const { Dashboard, Container, Wrapper, Title, Subtitle } = style

const Main = () => {
  return (
    <section className={Dashboard}>
      <div className={Container}>
        <h1 className={Title}>Всі акції ТАСКОМБАНКУ</h1>
        <div className={Wrapper}>
          {/* <PromoItem
            title={`Вигравай незабутню подорож!`}
            link="/travel"
            image={"https://tascombank.ua/uploads/1576925343327_1920kh900.jpg"}
          ></PromoItem> */}
          <PromoItem
            title={`Простий кредит готівкою! За 55 хвилин - отримайте кошти`}
            link="/cashnow"
            image={cashnow}
          ></PromoItem>
        </div>
      </div>
      <h2 className={Subtitle}>ТАСКОМБАНК — РАЗОМ ЗМОЖЕМО ВСЕ</h2>
    </section>
  )
}

export default Main
